import ArticleService from "./ArticleService";
import ProjectService from "./ProjectService";

const services = {
  project: ProjectService.prototype,
  article: ArticleService.prototype,
};

export default services;
